import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATHS from 'routes/values';
import { getUserIdFromLocalStorage } from 'helpers';
import { IRequiredAuthMiddleware } from './@types';

const RequiredAuthMiddleware: FC<IRequiredAuthMiddleware> = ({ children }) => {
  const userId = getUserIdFromLocalStorage();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) {
      navigate(ROUTE_PATHS.SIGN_UP);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default RequiredAuthMiddleware;
